import { useQuery } from '@tanstack/react-query';
import { countryRequest } from 'api/CountryRequest';
import { ApiResponseGetCountries } from 'api/types/country';
import { queryKeys } from '../../constants/queryKeys';

function useGetCountries(enabled?: boolean) {
  const QUERY_KEY = [queryKeys.countries];

  return useQuery<ApiResponseGetCountries[], Error>({
    queryKey: QUERY_KEY,
    queryFn: () => countryRequest.getCountries(),
    enabled,
  });
}
export default useGetCountries;
